<div class="flex flex-col gap-1 w-full animate-fade-in p-4">
  <app-header
    title="Audit Logs"
    searchPlaceholder="Search area, username, IP..."
    [showNew]="false"
    [showFilter]="false"
    (onSearch)="handleSearch($event)"
  ></app-header>
  <app-table
    [allData]="tableData"
    [columns]="tableColumns"
    [totalRecords]="totalItems"
    [loading]="loading"
    [rows]="10"
    [rowsPerPageOptions]="[5, 10, 20, 50]"
    (onLazyLoad)="loadAuditsLazy($event)"
  >
  </app-table>
</div>
